import React from 'react';
import { useSelector } from 'react-redux';
import { useFavoriteItems } from 'shared/hooks/favorites.hooks';
import { FavoritesPageComponent } from './Favorites.page.component';

/**
 * The Favorites route: contacts from the store, knowledge rows fetched by id.
 *
 * @returns {JSX.Element}
 * @example
 * <Route path={ROUTES.FAVORITES} element={<FavoritesPage />} />
 */
export function FavoritesPage() {
  const lang = useSelector(state => state.lang.FAVORITES_SCREEN);
  const { list, isLoading } = useFavoriteItems();

  return <FavoritesPageComponent lang={lang} list={list} loading={isLoading} />;
}
